"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawableAcceptBinding = drawableAcceptBinding;
function drawableAcceptBinding(dc, evt) {
    var drawableId = dc.state.selectedId;
    if (drawableId == null) {
        return;
    }
    if (evt.$event != null) {
        evt.$event.preventDefault();
    }
    var drawable = dc.selected;
    if (drawable == null) {
        return;
    }
    // Remove insight flags from the drawable, and the base / base offset
    drawable.approveInsightFlag();
    // This should not trigger as we don't support insight base & base offsets made by the back end yet
    if (dc.drawState.insightBase) {
        dc.drawState.insightBase.approveInsightFlag();
    }
    if (dc.drawState.insightBaseOffset) {
        dc.drawState.insightBaseOffset.approveInsightFlag();
    }
}
//# sourceMappingURL=drawable.accept.binding.js.map